(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AssignmentPreviewCtrl", ["$scope", assignmentPreviewCtrl]);
    function assignmentPreviewCtrl($scope) {
        var vm = this;
        var isEditPreview = $scope.$parent.vm.assignment.specificInfo.isEdit;
        if (isEditPreview)
            vm.model = {
                instructions: $scope.$parent.vm.assignment.specificInfo.assignment.instructions,
                fileName: $scope.$parent.vm.assignment.specificInfo.assignment.fileName,
                fileUrl: $scope.$parent.vm.assignment.specificInfo.assignment.fileUrl
            };
        else {
            vm.model = {
                instructions: $scope.$parent.vm.assignment.specificInfo.instructions
            };
            if ($scope.$parent.vm.assignment.specificInfo.template) {
                vm.model.fileName = $scope.$parent.vm.assignment.specificInfo.template.fileName;
                vm.model.fileUrl = $scope.$parent.vm.assignment.specificInfo.template.fileUrl;
            }
        }
    }
}());
